<template>
  <v-card height="100%">
    <project-flow-navigation-toolbar
      :title="masterplanName"
    ></project-flow-navigation-toolbar>
    <v-toolbar dense>
      <v-tabs v-model="tab">
        <v-tab href="#details"> Details </v-tab>
        <v-tab href="#media"> Media </v-tab>
        <v-tab href="#pois"> Points of interest </v-tab>

        <v-tab v-if="!isCommunity" href="#masterplans">
          Masterplans
        </v-tab>
        <v-tab v-if="!isCommunity" href="#community">
          Community
        </v-tab>
        <v-tab href="#buildings"> Buildings </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="tab">
      <v-tab-item value="details">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  class="mt-5"
                  dense
                  :key="masterplan.id"
                  v-model="masterplan.name"
                  label="Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  :items="communities"
                  class="mt-5"
                  dense
                  :key="masterplan.community"
                  v-model="masterplan.community"
                  label="community"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  class="mt-5"
                  dense
                  v-model="masterplan.parentId"
                  label="Parent Id"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-card-title style="margin-left: -12px">
                  ParentId should be configured by developers only!
                </v-card-title>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row class="ml-1 mb-1">
            <v-card-title>
              <div class="pr-2" v-if="getMasterplanTabTitle !== null">
                Masterplan is:
              </div>
              <div class="pr-2" v-else>Community is:</div>
              {{ `${masterplan.publish ? 'published' : 'unpublished'}` }}
            </v-card-title>
            <v-card-text>
              <v-switch
                v-if="dialogButton('active')"
                inset
                hide-details="auto"
                class="mt-0 ml-1"
                v-model="masterplan.publish"
              >
              </v-switch>
              <div class="text-center" v-if="dialogButton('deactive')">
                <v-dialog v-model="dialog" width="500">
                  <template v-slot:activator="{ on }">
                    <v-switch
                      v-on="on"
                      inset
                      hide-details="auto"
                      class="mt-0 ml-1 checkboxButton"
                      v-model="masterplan.publish"
                      disabled
                    >
                    </v-switch>
                  </template>

                  <v-card>
                    <v-card-title class="text-h5 lighten-2">
                      Publish Masterplan
                    </v-card-title>

                    <v-card-text>
                      The action is not possible because there is more than one
                      community/building visible inside this
                      masterplan/community.
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">
                        Ok
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-row>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deleteMasterplan">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span v-if="changeDetected" class="caption amber--text d-flex align-center mr-2">
                <v-icon x-small color="amber" class="mr-1">mdi-circle-medium</v-icon>Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="changeDetected" text @click="discard">Discard</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item value="media">
        <media
          v-if="showMedia"
          :media="this.$store.state.MediaStore.media"
          :is-visible="tab === 'media'"
        ></media>
        <v-card-subtitle v-if="!showMedia"
          >There is no default poi for this record, media is not available.
        </v-card-subtitle>
      </v-tab-item>
      <v-tab-item value="pois">
        <v-list-item>
          <v-list-item-content>
            <poi-list
              :poi-list="this.$store.state.PoiStore.pois"
              parentType="masterplan"
              :parent="this.$store.state.MasterplanStore.selectedMasterplan"
            ></poi-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
      <v-tab-item value="masterplans">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <masterplan-list
                  :masterplanList="
                    this.$store.state.MasterplanStore
                      .selectedMasterplansNestedMasterplans
                  "
                  :context="'masterplan'"
                ></masterplan-list>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="community">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <masterplan-list
                  :masterplanList="
                    this.$store.state.MasterplanStore
                      .selectedMasterplansNestedMasterplansCommunities
                  "
                  :context="'community'"
                ></masterplan-list>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="buildings">
        <v-list-item>
          <v-list-item-content>
            <building-list
              :buildingList="this.$store.state.BuildingStore.buildings"
            ></building-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import MasterplanList from '../../components/RecordLists/MasterplanList'
import BuildingList from '../../components/RecordLists/BuildingList'
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import Media from '../../views/Media'
import PoiList from '../../components/RecordLists/PoiList'
import { mapState } from 'vuex'
import MasterplanService from '../../services/MasterplanService'
import licensingEngine from '../../services/licensingEngine'

export default {
  name: 'MasterplanExpore',
  props: {},
  components: {
    BuildingList,
    MasterplanList,
    ProjectFlowNavigationToolbar,
    PoiList,
    Media
  },
  data: function() {
    return {
      pois: [],
      dialog: false,
      buildings: [],
      masterplan: {},
      title: '',
      tab: 'details',
      media: [],
      showMedia: false,
      changeDetected: false,
      licenses: [],
      isDisabled: true
    }
  },
  computed: {
    getNestedMasterplans() {
      return this.$store.state.MasterplanStore
        .selectedMasterplansNestedMasterplans
    },
    getMasterplanTabTitle() {
      if (this.$store.state.MasterplanStore.selectedMasterplan) {
        if (this.$store.state.MasterplanStore.selectedMasterplan.community) {
          return 'COMMUNITY'
        } else {
          return 'MASTERPLANS'
        }
      } else {
        return 'MASTERPLANS'
      }
    },
    masterplanName: function() {
      return this.$store.state.MasterplanStore.selectedMasterplan
        ? this.$store.state.MasterplanStore.selectedMasterplan.name
        : ''
    },
    ...mapState('MediaStore', ['selectedGallery']),
    saveButtonDisabled: function() {
      return !this.changeDetected
    }
    // masterplanComp: {
    //   get: function() {
    //     this.masterplan = this.$store.state.MasterplanStore.selectedMasterplan
    //     return this.masterplan
    //   },
    //   set: function(newValue) {
    //     this.masterplan = newValue
    //   }
    // }
  },
  watch: {
    selectedGallery: async function(newValue) {
      await this.$store.dispatch('MediaStore/fetchMedia')
    },
    masterplan: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.masterplan) !==
            JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan)
        }
      }
    },
    tab: async function(newValue) {
      // if (newValue === 'media') {
      //   await this.$store.dispatch('MediaStore/resetStore')
      //   await this.$store.dispatch('MediaStore/setMediaContext', 'poi')
      // }
    }
  },

  methods: {
    dialogButton(status) {
      let nestedMasterplans = this.getNestedMasterplans
      nestedMasterplans = nestedMasterplans.filter(el => el.publish === true)
      if (nestedMasterplans && nestedMasterplans.length > 0) {
        return status === 'active' ? true : false
      } else {
        let buildings = this.$store.state.BuildingStore.buildings
        buildings = buildings.filter(el => el.publish === true)
        if (buildings.length > 1) {
          return status === 'deactive' ? true : false
        } else {
          return status === 'deactive' ? false : true
        }
      }
    },
    //checking if license is configured in licensing engine and enables/disables nestedmasterplans accordingly
    async nestedMasterplansLicenseDisabled() {
      await licensingEngine().then(res => (this.licenses = res.data))
      if (this.licenses.licenses.length > 0) {
        this.isDisabled = false
      }
    },
    getData: async function(masterplanId) {
      if (masterplanId) {
        await this.$store.dispatch('MediaStore/resetStore')

        await this.$store.dispatch(
          'MasterplanStore/setSelectedMasterplan',
          masterplanId
        )

        await this.$store.dispatch('BuildingStore/fetchBuildings')
        await this.$store.dispatch('PoiStore/setPoiContext', 'masterplan')
        await this.$store.dispatch('PoiStore/fetchPois')

        this.masterplan = JSON.parse(
          JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan)
        )
        // find default poi
        let defaultPoi = this.$store.state.PoiStore.pois.find(el => {
          return el.poiTypeId === Enums.PoiType.poi_type_masterplan
        })
        if (defaultPoi) {
          await this.$store.dispatch('MediaStore/resetStore')
          await this.$store.dispatch('PoiStore/setSelectedPoi', defaultPoi.id)
          await this.$store.dispatch('MediaStore/setMediaContext', 'poi')

          // await this.$store.dispatch('MediaStore/fetchMediaTypes')
          // await this.$store.dispatch('MediaStore/fetchMedia')
          this.showMedia = true
        } else {
          this.showMedia = false
        }

        //this.media = this.$store.state.MediaStore.media
        // await this.$store.dispatch('MediaStore/setMediaContext', "poi")
        //       await this.$store.dispatch('MediaStore/fetchMedia')
        //       this.media = this.$store.state.MediaStore.Media
      }
    },
    save: async function() {
      await this.$store.dispatch(
        'MasterplanStore/updateMasterplan',
        this.masterplan
      )
      // Updateovanje masterplana se sada izvrsava u updateMasterplan akciji:
      // await this.$store.dispatch(
      //   'MasterplanStore/setSelectedMasterplan',
      //   this.$route.params.masterplanId
      // )
      this.masterplan = JSON.parse(
        JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan)
      )
      this.changeDetected = false
    },
    deleteMasterplan: async function() {
      this.$confirm({
        title: 'Delete Masterplan',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'MasterplanStore/deleteMasterplan',
              this.$route.params.masterplanId
            )
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message:
                      'Masterplan has child records, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {})
    },
    discard() {
      this.masterplan = JSON.parse(JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan))
      this.changeDetected = false
    }
  },
  created: function() {
    // if (localStorage.exploreMasterplanActiveTabs) {
    //   let temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //   let item = temp.find(
    //     element => element.mid === this.$route.params.masterplanId
    //   )
    //   if (item) this.tab = item.tab
    // }
  },
  async mounted() {
    this.nestedMasterplansLicenseDisabled()
    await this.getData(this.$route.params.masterplanId)
    let lastBreadcrumb = this.$store.state.BreadcrumbsStore.history[
      this.$store.state.BreadcrumbsStore.history.length - 1
    ]
    if (lastBreadcrumb && lastBreadcrumb.tab) {
      if (lastBreadcrumb.tab === 'BUILDING ') {
        this.tab = 'buildings'
      }
      if (
        lastBreadcrumb.text === 'MASTERPLAN ' &&
        lastBreadcrumb.tab === 'COMMUNITY '
      ) {
        this.tab = 'masterplans'
      }
      if (
        lastBreadcrumb.text === 'MASTERPLAN ' &&
        lastBreadcrumb.tab === 'MASTERPLAN '
      ) {
        this.tab = 'masterplans'
      }
      if (lastBreadcrumb.tab === 'P.O.I ') {
        this.tab = 'pois'
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.$store.dispatch('MediaStore/resetStore')
    })
  },
  async beforeRouteUpdate(to, from, next) {
    await this.$store.dispatch('MediaStore/resetStore')
    // this.getData(to.params.masterplanId)
    // if (!localStorage.exploreMasterplanActiveTabs) {
    //   localStorage.exploreMasterplanActiveTabs = JSON.stringify([
    //     {
    //       tab: this.tab,
    //       mid: from.params.masterplanId
    //     }
    //   ])
    // } else {
    //   var temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //   var foundIndex = temp.findIndex(
    //     element => element.mid == this.$route.params.masterplanId
    //   )
    //   if (foundIndex !== -1) {
    //     temp[foundIndex].tab = this.tab
    //   } else {
    //     temp.push({
    //       tab: this.tab,
    //       mid: from.params.masterplanId
    //     })
    //   }
    //
    //   localStorage.exploreMasterplanActiveTabs = JSON.stringify(temp)
    // }
    next()
  },
  beforeRouteLeave(to, from, next) {
    // if (
    //   to.name == 'Explore Poi' ||
    //   to.name == 'Explore Masterplan' ||
    //   to.name == 'Explore Building'
    // ) {
    //   if (!localStorage.exploreMasterplanActiveTabs) {
    //     localStorage.exploreMasterplanActiveTabs = JSON.stringify([
    //       {
    //         tab: this.tab,
    //         mid: from.params.masterplanId
    //       }
    //     ])
    //   } else {
    //     let temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //     var foundIndex = temp.findIndex(
    //       element => element.mid == this.$route.params.masterplanId
    //     )
    //     if (foundIndex !== -1) {
    //       temp[foundIndex].tab = this.tab
    //     } else {
    //       temp.push({
    //         tab: this.tab,
    //         mid: from.params.masterplanId
    //       })
    //     }
    //
    //     localStorage.exploreMasterplanActiveTabs = JSON.stringify(temp)
    //   }
    // } else {
    //   if (localStorage.exploreMasterplanActiveTabs) {
    //     let temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //     temp = temp.filter(function(value, index, arr) {
    //       if (value.mid == to.params.masterplanId) return true
    //     })
    //     localStorage.exploreMasterplanActiveTabs = JSON.stringify(temp)
    //   }
    // }
    next()
  },
  data: function() {
    return {
      pois: [],
      dialog: false,
      buildings: [],
      masterplan: {},
      title: '',
      tab: 'details',
      media: [],
      communities: [true, false],
      showMedia: false,
      changeDetected: false,
      checkboxDisabled: false,
      licenses: [],
      isDisabled: true,
      isCommunity: false
    }
  },
  computed: {
    getMasterplanTabTitle() {
      if (this.$store.state.MasterplanStore.selectedMasterplan) {
        if (this.$store.state.MasterplanStore.selectedMasterplan.community) {
          return 'COMMUNITY'
        } else {
          return 'MASTERPLANS'
        }
      } else {
        return 'MASTERPLANS'
      }
    },
    masterplanName: function() {
      return this.$store.state.MasterplanStore.selectedMasterplan
        ? this.$store.state.MasterplanStore.selectedMasterplan.name
        : ''
    },
    ...mapState('MediaStore', ['selectedGallery']),
    saveButtonDisabled: function() {
      return !this.changeDetected
    }
    // masterplanComp: {
    //   get: function() {
    //     this.masterplan = this.$store.state.MasterplanStore.selectedMasterplan
    //     return this.masterplan
    //   },
    //   set: function(newValue) {
    //     this.masterplan = newValue
    //   }
    // }
  },
  watch: {
    selectedGallery: async function(newValue) {
      await this.$store.dispatch('MediaStore/fetchMedia')
    },
    '$store.state.MasterplanStore.selectedMasterplan'() {
      return (this.isCommunity = this.$store.state.MasterplanStore.selectedMasterplan.community)
    },
    masterplan: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.masterplan) !==
            JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan)
        }
      }
    },
    tab: async function(newValue) {
      // if (newValue === 'media') {
      //   await this.$store.dispatch('MediaStore/resetStore')
      //   await this.$store.dispatch('MediaStore/setMediaContext', 'poi')
      // }
    }
  },

  methods: {
    dialogButton(status) {
      let nestedMasterplans = this.$store.state.MasterplanStore
        .selectedMasterplansNestedMasterplans
      nestedMasterplans = nestedMasterplans.filter(el => el.publish === true)
      if (nestedMasterplans && nestedMasterplans.length > 0) {
        if (nestedMasterplans.length > 1) {
          return status === 'active' ? false : true
        } else {
          return status === 'active' ? true : false
        }
      } else {
        let buildings = this.$store.state.BuildingStore.buildings
        buildings = buildings.filter(el => el.publish === true)
        if (buildings.length > 1) {
          return status === 'active' ? false : true
        } else {
          return status === 'active' ? true : false
        }
      }
    },
    //checking if license is configured in licensing engine and enables/disables nestedmasterplans accordingly
    async nestedMasterplansLicenseDisabled() {
      await licensingEngine().then(res => (this.licenses = res.data))
      if (this.licenses.licenses.length > 0) {
        this.isDisabled = false
      }
    },
    getData: async function(masterplanId) {
      if (masterplanId) {
        await this.$store.dispatch('MediaStore/resetStore')
        await this.$store.dispatch(
          'MasterplanStore/setSelectedMasterplan',
          parseInt(masterplanId),
          {
            root: true
          }
        )
        await this.$store.dispatch('BuildingStore/fetchBuildings')
        await this.$store.dispatch('PoiStore/setPoiContext', 'masterplan')
        await this.$store.dispatch('PoiStore/fetchPois')

        this.masterplan = JSON.parse(
          JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan)
        )
        if (this.masterplan.parentId > 0) {
          const parentMasterplan = await MasterplanService.getMasterplanById(
            this.masterplan.parentId
          )
          if (!parentMasterplan.data.publish) {
            this.checkboxDisabled = true
          }
        }
        // find default poi
        let defaultPoi = this.$store.state.PoiStore.pois.find(el => {
          return el.poiTypeId === Enums.PoiType.poi_type_masterplan
        })
        if (defaultPoi) {
          await this.$store.dispatch('MediaStore/resetStore')
          await this.$store.dispatch('PoiStore/setSelectedPoi', defaultPoi.id)
          await this.$store.dispatch('MediaStore/setMediaContext', 'poi')

          // await this.$store.dispatch('MediaStore/fetchMediaTypes')
          // await this.$store.dispatch('MediaStore/fetchMedia')
          this.showMedia = true
        } else {
          this.showMedia = false
        }

        //this.media = this.$store.state.MediaStore.media
        // await this.$store.dispatch('MediaStore/setMediaContext', "poi")
        //       await this.$store.dispatch('MediaStore/fetchMedia')
        //       this.media = this.$store.state.MediaStore.Media
      }
    },
    save: async function() {
      await this.$store.dispatch(
        'MasterplanStore/updateMasterplan',
        this.masterplan
      )
      // Updateovanje masterplana se sada izvrsava u updateMasterplan akciji:
      // await this.$store.dispatch(
      //   'MasterplanStore/setSelectedMasterplan',
      //   this.$route.params.masterplanId
      // )
      this.masterplan = JSON.parse(
        JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan)
      )
      this.changeDetected = false
    },
    deleteMasterplan: async function() {
      this.$confirm({
        title: 'Delete Masterplan',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'MasterplanStore/deleteMasterplan',
              this.$route.params.masterplanId
            )
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message:
                      'Masterplan has child records, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {})
    }
  },
  created: function() {
    // if (localStorage.exploreMasterplanActiveTabs) {
    //   let temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //   let item = temp.find(
    //     element => element.mid === this.$route.params.masterplanId
    //   )
    //   if (item) this.tab = item.tab
    // }
  },
  async mounted() {
    this.nestedMasterplansLicenseDisabled()
    await this.getData(this.$route.params.masterplanId)
    let lastBreadcrumb = this.$store.state.BreadcrumbsStore.history[
      this.$store.state.BreadcrumbsStore.history.length - 1
    ]
    if (lastBreadcrumb && lastBreadcrumb.tab) {
      if (lastBreadcrumb.tab === 'BUILDING ') {
        this.tab = 'buildings'
      }
      if (
        lastBreadcrumb.text === 'MASTERPLAN ' &&
        lastBreadcrumb.tab === 'COMMUNITY '
      ) {
        this.tab = 'masterplans'
      }
      if (
        lastBreadcrumb.text === 'MASTERPLAN ' &&
        lastBreadcrumb.tab === 'MASTERPLAN '
      ) {
        this.tab = 'masterplans'
      }
      if (lastBreadcrumb.tab === 'P.O.I ') {
        this.tab = 'pois'
      }
    }
  }
}
</script>

<style lang="scss">
.v-window__container {
  height: 100%;
  .full-height-card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
.checkboxButton {
  opacity: 1 !important;
  pointer-events: all !important;
}
</style>
